import { useState } from "react";

import DocumentRow from "../DocumentRow/DocumentRow";
import TextPanel from "../common/TextPanel";
import PanelActionBarComponent from "../common/PanelActionBarComponent";
import GenrateDocument from "../GenrateDocument/GenrateDocument";
import ContactPanelForTreatment from "../TreatmentPage/components/ContactPanelForTreatment";
import TreatmentNotesSection from "../TreatmentPage/NotesTreatmentSection";
import InfoPanelWithoutKeyValue from "../ClientDashboard/shared/InfoPanelWithoutKeyValue";
import birthdayIcon from "../../assets/images/birthdayicon.svg";
import ConfirmDeletePopup from "../DefendantPage/DefandantMain/ConfirmDeletePopup";
import CounselMain from "../DefendantPage/Counsel/CounselMain";
import { api_without_cancellation } from "../../api/api";
import { calculateAge, formatCalendarDate } from "../../Utils/helper";
import "../common/RecordPanel.css";

function WitnessesMain({ object, handleFetchWitnesses = () => {}, onEditWitness }) {
  // const [addInsuranceModalShow, setAddInsuranceModalShow] = useState(false);

  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const [forDeleteCounselId, setForDeleteCounselId] = useState(null);
  const [showDeleteCounselConfirm, setShowDeleteCounselConfirm] = useState(false);
  const [dropdownName, setDropdownName] = useState(null);

  const handleGenrateDocument = (instanceId, name) => {
    setInstanceIdForGenragteDoc(instanceId);
    setDropdownName(name);
    setShowDocument(true);
  };

  //Delete OpposingCounsel is handeled here
  const handleDeleteCounselSubmission = async () => {
    try {
      const response = await api_without_cancellation.delete(
        `/api/defendants/delete_opposing_counsel/${forDeleteCounselId}/`
      );
      if (response.status === 204) {
        setShowDeleteCounselConfirm(false);
        handleFetchWitnesses();
      }
    } catch (error) {
      console.error("Error deleting counsel:", error);
    }
  };

  const buttonData = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: (id, name) => handleGenrateDocument(id, name),
    },
  ];

  const getPartyIcon = (partyType) => {
    switch (partyType?.toLowerCase()) {
      case "client":
        return "ic ic-15 ic-client m-r-5";
      case "defendant":
        return "ic ic-15 ic-defendants m-r-5";
      case "other party":
        return "ic ic-15 ic-parties m-r-5";
      default:
        return "ic ic-15 ic-parties m-r-5";
    }
  };

  const getPartyIcon2 = (partyType) => {
    switch (partyType?.toLowerCase()) {
      case "client":
        return <i className="ic ic-15 ic-client m-r-5" />;
      case "defendant":
        return <i className="ic ic-15 ic-defendants m-r-5" />;
      case "other party":
        return <i className="ic ic-15 ic-parties m-r-5" />;
      default:
        return <i className="ic ic-15 ic-parties m-r-5" />;
    }
  };
  const personalData = [
    {
      label: "For",
      value: object?.witness_for_name,
      value_icon_className: getPartyIcon(object?.witness_for_entity),
    },
    {
      label_icon: birthdayIcon,
      label: formatCalendarDate(object?.witness_birthday),
      value: `Age ${calculateAge(object?.witness_birthday)} ${object?.witness_gender}`,
    },
    {
      label: "Contact",
      value: formatCalendarDate(object?.contact_confirmed_date),
    },
    {
      label: "Letter",
      value: formatCalendarDate(object?.RepLetterSent),
    },
  ];
  const firstName = object?.witness_first_name?.trim() || "";
  const lastName = object?.witness_last_name?.trim() || "";
  const name = `${firstName} ${lastName}`.trim();
  const type = (
    <div className="d-flex align-items-center" style={{ fontWeight: "600" }}>
      {getPartyIcon2(object.witness_for_entity)}
      <span className="text-truncate">{object.witness_for_name || ""}</span>
    </div>
  );
  return (
    <>
      <div className="report record-panel" key={object?.id}>
        <PanelActionBarComponent
          compact
          id={object?.id}
          page_id={10}
          title={object?.witness_title}
          first_name={object?.witness_first_name}
          last_name={object?.witness_last_name}
          report_type_name={"Witness"}
          name={`${object?.witness_first_name ?? ""} ${object?.witness_last_name ?? ""}`}
          type={type}
        />
        <div className="flex-row d-flex record-panel-body flex-wrap" style={{ overflow: "hidden" }}>
          <div className="leins-container-three">
            <div className="min-w-260px-client">
              <ContactPanelForTreatment
                id={object?.id}
                panel_name="Witness"
                className="m-b-0"
                pageName={"treatment"}
                name={name}
                address1={object?.witness_contact_home?.address1}
                address2={object?.witness_contact_home?.address2}
                city={object?.witness_contact_home?.city}
                state={object?.witness_contact_home?.state}
                zip_code={object?.witness_contact_home?.zip}
                phone_number={object?.witness_contact_home?.phone_number}
                ext={object?.witness_contact_home?.phone_ext}
                fax_number={object?.witness_contact_home?.fax}
                email={object?.witness_contact_home?.email}
                websiteUrl={object?.witness_contact_home?.website}
                buttonData={buttonData}
                genrate_doc_address={16}
                templateDropdownId={16}
                templatePageId={10}
                onSelectObject={() => onEditWitness?.(object)}
              />
            </div>

            <div className="min-w-260px-client">
              <InfoPanelWithoutKeyValue
                id={object?.id}
                panel_name="Witness Details"
                panelClassName="p-0 panel-widths"
                data={personalData}
                onSelectReport={() => onEditWitness?.(object)}
                hasBtn={false}
              />
            </div>

            <div className="min-w-260px-client">
              <TextPanel
                object={object}
                panel_name="Witness Statement Summary"
                className="info-div-witness-statement-summary"
                onSelect={() => onEditWitness?.(object)}
              />
            </div>
          </div>
          <div
            className=""
            style={{
              flex: 1,
              minHeight: "155px",
              paddingRight: "0px",
              scrollbarWidth: "none",
              minWidth: "min(400px, 100%)",
            }}
          >
            <p className="menu-bar-style columnsTitle text-center">Notes</p>
            <TreatmentNotesSection
              entity_type={"Witnesses"}
              record_id={object?.id}
              module={"Witnesses"}
              pagePanels={3}
            />
          </div>
        </div>
        <div className="documents-wrapper m-t-5">
          <div className="col-12">
            {/* <div className="height-25">
              <h4 className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case background-main-10 font-weight-semibold text-center client-contact-title">
                &nbsp;Document Row
              </h4>
            </div> */}
            <DocumentRow clientProvider={object} page_id={10} showSaveToPage={false} />
          </div>
        </div>
      </div>

      {object?.witness_counsel &&
        object.witness_counsel.map((data, index) => {
          return (
            <CounselMain
              key={index}
              opposingcounsel={data}
              entity_name={"Defendant"}
              For_instance_name={
                object?.witness_last_name && object?.witness_first_name
                  ? `${object?.witness_last_name}, ${object?.witness_first_name}`
                  : object?.witness_last_name || object?.witness_first_name || "-"
              }
              handleFacthDefendants={handleFetchWitnesses}
              setForDeleteCounselId={setForDeleteCounselId}
              showDeleteCounselConfirm={setShowDeleteCounselConfirm}
              isDef={true}
            />
          );
        })}

      {showDeleteCounselConfirm && (
        <ConfirmDeletePopup
          entity="Counsel"
          handleClose={() => {
            setShowDeleteCounselConfirm(false);
          }}
          handleDeleteSubmission={handleDeleteCounselSubmission}
        />
      )}

      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="Witnesses"
          instanceId={instanceIdForGenrateDoc}
          dropdownName={dropdownName}
        />
      )}
    </>
  );
}

export default WitnessesMain;
